module.exports = __webpack_public_path__ + "static/media/icn_old_age_covid_fisdom.a7b1b64c.svg";